<template>
  <a-button type="primary" @click="getOXml" :loading="loading">
    get OXML
  </a-button>
</template>
<script>
export default {
  data() {
    return { loading: false };
  },
  methods: {
    getOXml() {
      this.loading = true;
      // Run a batch operation against the Word object model.
      Word.run(context => {
        // Create a proxy object for the document body.
        const body = context.document.body;

        // Queue a command to get the OOXML contents of the body.
        const bodyOOXML = body.getOoxml();

        // Synchronize the document state by executing the queued commands,
        // and return a promise to indicate task completion.
        return context.sync().then(() => {
          this.loading = false;
          console.log("Body OOXML contents: ", bodyOOXML.value);
        });
      }).catch(error => {
        this.loading = false;
        console.log("Error: " + JSON.stringify(error));
        if (error instanceof OfficeExtension.Error) {
          console.log("Debug info: " + JSON.stringify(error.debugInfo));
        }
      });
    }
  }
};
</script>
